import {
    URLAPI,
    TYPE_SHIPPING_REQUEST_PATH,
    TYPE_SHIPPING_REQUEST_CREATE_PATH,
    TYPE_SHIPPING_REQUEST_UPDATE_PATH,
    TYPE_SHIPPING_REQUEST_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_type_shipping_request: {
        data: [],

        status: 0,
        message: {},
    },

    _create_type_shipping_request: {
        data: {},
        status: 0,
        message: {},
    },
    _update_type_shipping_request: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_type_shipping_request: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_TYPE_SHIPPING_REQUEST = "GET_ALL_TYPE_SHIPPING_REQUEST";
export const CREATE_TYPE_SHIPPING_REQUEST = "CREATE_TYPE_SHIPPING_REQUEST";
export const UPDATE_TYPE_SHIPPING_REQUEST = "UPDATE_TYPE_SHIPPING_REQUEST";
export const DELETE_TYPE_SHIPPING_REQUEST = "DELETE_TYPE_SHIPPING_REQUEST";

export const type_shipping_request_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_TYPE_SHIPPING_REQUEST:
            return {
                ...state,
                _get_all_type_shipping_request: action.payload,
            };
        case CREATE_TYPE_SHIPPING_REQUEST:
            return {
                ...state,
                _create_type_shipping_request: action.payload,
            };
        case UPDATE_TYPE_SHIPPING_REQUEST:
            return {
                ...state,
                _update_type_shipping_request: action.payload,
            };
        case DELETE_TYPE_SHIPPING_REQUEST:
            return {
                ...state,
                _delete_type_shipping_request: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllTypeShippingRequest = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${TYPE_SHIPPING_REQUEST_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_TYPE_SHIPPING_REQUEST,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_TYPE_SHIPPING_REQUEST,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_TYPE_SHIPPING_REQUEST,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

//create type_shipping_request
export const createTypeShippingRequest = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${TYPE_SHIPPING_REQUEST_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_TYPE_SHIPPING_REQUEST,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_TYPE_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_TYPE_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateTypeShippingRequest = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${TYPE_SHIPPING_REQUEST_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_TYPE_SHIPPING_REQUEST,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_TYPE_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_TYPE_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteTypeShippingRequest = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `${URLAPI}${TYPE_SHIPPING_REQUEST_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_TYPE_SHIPPING_REQUEST,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_TYPE_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_TYPE_SHIPPING_REQUEST,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_type_shipping_request = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
